module.exports = __webpack_public_path__ + "static/media/walk_n_talk.82469ebf.jpg";